import React, { createContext, useState, useContext } from 'react';

const UsernameContext = createContext();

export const UsernameProvider = ({ children }) => {
  const [contextUsername, setContextUsername] = useState(null);

  return (
    <UsernameContext.Provider value={{ contextUsername, setContextUsername}}>
      {children}
    </UsernameContext.Provider>
  );
};

export const useUsername = () => useContext(UsernameContext);